import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { employee, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Checking account...
      </div>
    );
  }

  if (!employee) {
    return <Navigate to="/login" replace />;
  }

  if (
    employee.status === "blocked" ||
    employee.status === "inactive" ||
    employee.status === false
  ) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
